module.exports = __webpack_public_path__ + "resources/icon_44_down_small_active.ce6359528ead30d4.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_down_small_active.png
// module id = 484
// module chunks = 0 1 2 3 4